export const categoryToType = {
  cart: "cartTag",
  tag: "personTag",
};

export const colorMap = {
  black: "#232526",
  green: "#52C41A",
  orange: "#FAAD14",
  yellow: "#FAAD14",
  red: "#F5222D",
  blue: "#42B0D5",
  grey: "#B9C2C9",
  lightGrey: "#E4E8ED",
};

export const defaultMapConfig = {
  gridRowHeight: 3,
  xScaleFactor: 1,
  yScaleFactor: 0.5,
  xPadding: 6,
  yPadding: 1,
  colors: colorMap,
};
